import { render, staticRenderFns } from "./MarketCheckout.vue?vue&type=template&id=05fe7a45&"
import script from "./MarketCheckout.vue?vue&type=script&lang=js&"
export * from "./MarketCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports